"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UpdateQuerystring = void 0;

UpdateQuerystring = function UpdateQuerystring(key, value, url) {
  var hash = void 0;
  var re = void 0;
  var separator = void 0;
  if (!url) {
    url = window.location.href;
  }
  re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi");
  hash = void 0;
  if (re.test(url)) {
    if (typeof value !== "undefined" && value !== null) {
      return url.replace(re, "$1" + key + "=" + value + "$2$3");
    } else {
      hash = url.split("#");
      url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
      if (typeof hash[1] !== "undefined" && hash[1] !== null) {
        url += "#" + hash[1];
      }
      return url;
    }
  } else {
    if (typeof value !== "undefined" && value !== null) {
      separator = url.includes("?") ? "&" : "?";
      hash = url.split("#");
      url = hash[0] + separator + key + "=" + value;
      if (typeof hash[1] !== "undefined" && hash[1] !== null) {
        url += "#" + hash[1];
      }
      return url;
    } else {
      return url;
    }
  }
};

exports.default = UpdateQuerystring;